// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExpandButton__button___KBTXW {
    display: inline-flex;
    justify-content: center;
    width: 100%;
    color: var(--color-bg-ghost);

    &:hover {
        background-color: var(--color-bg-stripe);
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/ExpandableContent/ExpandButton/ExpandButton.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,4BAA4B;;IAE5B;QACI,wCAAwC;IAC5C;AACJ","sourcesContent":[".button {\n    display: inline-flex;\n    justify-content: center;\n    width: 100%;\n    color: var(--color-bg-ghost);\n\n    &:hover {\n        background-color: var(--color-bg-stripe);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ExpandButton__button___KBTXW`
};
export default ___CSS_LOADER_EXPORT___;
